export const darkTheme = {
    bg: "#050505", // Deep, near-black background matching the 3D aesthetic
    bgLight: "#111111", // Slightly lighter for subtle contrast
    primary: "#3b82f6", // A vibrant blue accent
    text_primary: "#fafafa",
    text_secondary: "#a1a1aa",
    card: "rgba(10, 15, 30, 0.95)", // Blue-tinted, less transparent layout
    card_light: "rgba(15, 23, 42, 0.98)", // For hovered items or inners
    button: "#3b82f6",
    white: "#FFFFFF",
    black: "#000000",
    skillcard_bg: "rgba(20, 20, 20, 0.7)", 
    exp_bg: "rgba(25, 25, 25, 0.7)",
    tags: "#d8b4fe", // Lighter purple for tags
};

export const lightTheme = {
  // Can be kept similar if they don't use it, but adapting slightly
    bg: "#FAFAFA",
    bgLight: "#F4F4F5",
    primary: "#9333ea",
    text_primary: "#18181b",
    text_secondary: "#52525b",
    card: "rgba(255, 255, 255, 0.8)",
    button: "#9333ea",
    skillcard_bg: "rgba(240, 240, 240, 0.7)",
    exp_bg: "rgba(230, 230, 230, 0.7)",
    tags: "#d8b4fe",
};